import { Group, InputLabel, InputLabelProps, Text } from '@mantine/core';
import { useMemo } from 'react';

import inputStyles from '../styles/Input.module.css';

export interface TextareaLabelProps extends InputLabelProps {
    withAsterisk?: boolean;
    characterCount?: number;
    maxLength?: number;
    showCharacterCount?: boolean;
}

export const TextareaLabel = (props: TextareaLabelProps) => {
    const characterCountLabel = useMemo<string | null>(() => {
        const showMaxLength = Number.isInteger(props.maxLength);
        if (!props.showCharacterCount && !showMaxLength) {
            return null;
        }

        const characterCount = props.characterCount ?? 0;

        if (showMaxLength) {
            return `${characterCount}/${props.maxLength}`;
        }

        return characterCount.toString();
    }, [props.characterCount, props.maxLength, props.showCharacterCount]);

    return (
        <Group w="full" justify="space-between">
            <Group gap={2}>
                <InputLabel {...props}>{props.children}</InputLabel>
                {Boolean(props.withAsterisk) && (
                    <Text className={inputStyles.required} span>
                        *
                    </Text>
                )}
            </Group>
            {Boolean(characterCountLabel) && (
                <Text c="var(--text-contrast-low)" size="xs">
                    {characterCountLabel}
                </Text>
            )}
        </Group>
    );
};
